import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { FormControl, ButtonToolbar, Button } from 'react-bootstrap';

import Colors from '../../styles/colors';
import { LadShape } from '../../components/lads';
import { Privileges, hasPrivileges } from '../auth/authorization';


class LadLabelForm extends React.Component {

  state = { currentLabel: this.props.originalLabel };
  
  handleChange = event => {
    const newLabel = event.target.value;
    this.setState({ currentLabel: newLabel });
  };
  
  handleSave = event => {
    const { currentLabel: newLabel } = this.state;
    const { lad, updateLadLabel } = this.props;
    updateLadLabel(lad, newLabel);
  };
  
  handleCancel = event => {
    this.setState({ currentLabel: this.props.originalLabel });
  };

  render() {
    const { currentLabel } = this.state;
    const { lad, height, originalLabel } = this.props;
    const { default_name: defaultLabel } = lad;
    const isDirty = (originalLabel !== currentLabel);

    const readOnly = !hasPrivileges([Privileges.MANAGE_LOCATIONS]);

    return (
      <glamorous.Div
        marginLeft="0.5em"
        marginRight="0.5em"
        width="100%"
      >
        <FormControl
          disabled={readOnly}
          onChange={this.handleChange}
          value={currentLabel}
          style={{
            height: `${height}px`,
            width: "100%",
            borderRadius: "2px",
            fontSize: "1.2em"
          }}
        />
        <glamorous.Div
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <glamorous.P
            color={Colors.editLadsLabelText}
            paddingTop=".3em"
            fontWeight="light"
          >
            <em>Default:</em> <strong>{defaultLabel}</strong>
          </glamorous.P>
          {isDirty &&
            <ButtonToolbar>
              <Button bsSize="xsmall" onClick={this.handleCancel}>Cancel</Button>
              <Button bsSize="xsmall" bsStyle="success" onClick={this.handleSave}>Save</Button>
            </ButtonToolbar>
          }
        </glamorous.Div>
      </glamorous.Div>
    );
  }
}
LadLabelForm.propTypes = {
  lad: PropTypes.shape(LadShape).isRequired,
  originalLabel: PropTypes.string.isRequired,
  updateLadLabel: PropTypes.func.isRequired,
  height: PropTypes.number,
};

export default LadLabelForm;



// WEBPACK FOOTER //
// ./src/modules/lads/LadLabelForm.js